export default "__VITE_ASSET__8baf1219__"